<!--
/**
* @name: Detail.vue
* @description: 分销员详情页面
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false" :class="css.query_item">
      <y-query-item>
        <h3>基本信息</h3>
      </y-query-item>
    </y-query>
    <!-- 基本信息区域 -->
    <y-form titleAlign="right" titleWidth="100px" contentWidth="400px">
      <y-form-item title="客商编码:" required>
        <k-input v-model="memberInfo.customerCode" placeholder="客商编码" block disabled></k-input>
      </y-form-item>
      <y-form-item title="角色名称:" required>
        <k-select v-model="memberInfo.type" disabled block placeholder="请选择角色名称">
          <k-option v-for="(item, index) in roleList" :selected="memberInfo.type == item.value" :key="index" :value="item.value" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-form-item>
      <y-form-item title="门店编码:" required>
        <k-input v-model="memberInfo.shopCode" placeholder="门店编码" block disabled></k-input>
      </y-form-item>
      <y-form-item title="会员ID:" required>
        <k-input v-model="memberInfo.id" placeholder="会员ID" block disabled></k-input>
      </y-form-item>
      <y-form-item title="所属推广公司:" required>
        <k-input v-model="memberInfo.companyName" placeholder="所属推广公司" block disabled></k-input>
      </y-form-item>
      <y-form-item title="微店账号:" required>
        <k-input v-model="memberInfo.smallShopCode" placeholder="微店账号" block disabled></k-input>
      </y-form-item>
      <y-form-item title="销售渠道:" required>
        <k-input v-model="memberInfo.channelName" placeholder="销售渠道" block disabled></k-input>
      </y-form-item>
      <y-form-item title="会员账号:" required>
        <k-input v-model="memberInfo.account" placeholder="会员账号" block disabled></k-input>
      </y-form-item>
      <y-form-item title="手机号码:">
        <insensitive :val="memberInfo.phone"></insensitive>
      </y-form-item>

      <y-form-item title="注册时间:" required>
        <k-input v-model="memberInfo.createTime" placeholder="注册时间" block disabled></k-input>
      </y-form-item>
    </y-form>
    <!-- 基本信息区域 end -->
    <y-query spaceBetween :hasSearchButton="false" :class="css.query_item">
      <y-query-item>
        <h3>资产情况</h3>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false" :class="css.query">
      <y-query-item :class="css.label">账户余额：</y-query-item>
      <y-query-item :class="css.value">￥126,560</y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <y-button size="mini" @click="openPopupIncomeShow">查看收益明细</y-button>
      </y-query-item>
      <y-query-item>
        <y-button size="mini" @click="openPopupRemmitShow">查看提现明细</y-button>
      </y-query-item>
    </y-query>
    <!-- 查看收益明细弹窗区域 -->
    <k-popup bind="v-if" layout="header,body,close,mask" title="收益明细列表" :show.sync="popupIncomeShow">
      <div style="width: 650px;">
        <k-table :data="incomeList" height="600px" :rightFixedNumber="1" :columns="initIncomeTableColumns()"></k-table>
      </div>
    </k-popup>
    <!-- 查看收益明细弹窗区域 end-->
    <!-- 查看提现明细弹窗区域 -->
    <k-popup bind="v-if" layout="header,body,close,mask" title="提现明细列表" :show.sync="popupRemmitShow">
      <div style="width: 650px;">
        <k-table :data="remmitList" height="600px" :rightFixedNumber="1" :columns="initRemmitTableColumns()"></k-table>
      </div>
    </k-popup>
    <!-- 查看提现明细弹窗区域 end-->
    <y-query spaceBetween :hasSearchButton="false" :class="css.query_item">
      <y-query-item>
        <h3>收款账户信息</h3>
      </y-query-item>
    </y-query>
    <y-form titleAlign="right" class="mt-3" titleWidth="100px" contentWidth="400px">
      <y-form-item title="打款类型:" required>
        <k-select disabled block v-model="memberInfo.bank.remitType">
          <k-option v-for="item in payTypeList" :key="item.value" :value="item.value" :label="item.name" :selected="memberInfo.bank.remitType == item.value">{{ item.name }}</k-option>
        </k-select>
      </y-form-item>
      <y-form-item title="银行名称:" required>
        <k-input v-model="memberInfo.bank.bankName" placeholder="银行名称" block disabled></k-input>
      </y-form-item>
      <y-form-item title="开户行:">
        <k-input v-model="memberInfo.bank.depositBank" placeholder="开户行" block disabled></k-input>
      </y-form-item>
      <y-form-item title="行号:">
        <k-input v-model="memberInfo.bank.bankNumber" placeholder="行号" block disabled></k-input>
      </y-form-item>
      <y-form-item title="账户名称:" required>
        <k-input v-model="memberInfo.bank.accountName" placeholder="账户名称" block disabled></k-input>
      </y-form-item>
      <y-form-item title="银行卡号:" required>
        <insensitive :val="memberInfo.bank.bankCardNumber"></insensitive>
      </y-form-item>
      <y-form-item title="预留手机号码:" required>
        <insensitive :val="memberInfo.bank.bankReservedPhone"></insensitive>
      </y-form-item>
      <y-form-item title="身份证号码:">
        <insensitive :val="memberInfo.bank.payeeIdCard"></insensitive>
      </y-form-item>
      <y-form-item title="身份证正面:">
        <y-image v-dragging="{ list: [memberInfo.bank.idCardFront], item: img, group: 'image' }" v-for="(img, index) in [memberInfo.bank.idCardFront]" :key="index" :index="index" :src="img"></y-image>
      </y-form-item>
      <y-form-item title="身份证反面:">
        <y-image
          v-dragging="{ list: [memberInfo.bank.idCardReverse], item: img, group: 'image' }"
          v-for="(img, index) in [memberInfo.bank.idCardReverse]"
          :key="index"
          :index="index"
          :src="img"
        ></y-image>
      </y-form-item>
    </y-form>
  </y-view>
</template>

<script>
import { NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE, NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_INFO_BYID } from "@/assets/modules/apiList";
const initPara = () => ({
  id: "",
});
export default {
  data() {
    return {
      isLoading: false,
      memberInfo: {
        channelName: "",
        id: "",
        phone: "",
        shopName: "",
        companyName: "",
        type: "",
        createTime: "",
        bank: {
          remitType: "",
          bankName: "",
          depositBank: "",
          bankNumber: "",
          accountName: "",
          bankCardNumber: "",
          bankReservedPhone: "",
          payeeIdCard: "",
        },
        idCard: {
          idCardFront: "",
          idCardReverse: "",
        },
      },
      payTypeList: [],
      para: initPara(),
      incomeList: [{}, {}],
      remmitList: [{}, {}],
      popupIncomeShow: false,
      popupRemmitShow: false,
      roleList: [],
    };
  },
  filters: {},
  methods: {
    initIncomeTableColumns() {
      return [
        {
          name: "时间（从近到远）",
          field: "",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "收益类型",
          field: "",
          style: {
            width: 150,
            textAlign: "center",
          },
        },
        {
          name: "收益总额",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "订单号",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "订单金额",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
      ];
    },
    initRemmitTableColumns() {
      return [
        {
          name: "时间（从近到远）",
          field: "",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          name: "提现金额",
          field: "",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
        {
          name: "流水单号",
          field: "",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
        {
          name: "银行卡号",
          field: "",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
        {
          name: "状态",
          field: "",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
      ];
    },
    openPopupIncomeShow() {
      this.popupIncomeShow = true;
    },
    openPopupRemmitShow() {
      this.popupRemmitShow = true;
    },
    //打款类型列表
    getPayTypeList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "payType",
        },
      }).then((res) => {
        this.payTypeList = res || [];
      });
    },
    getRoleList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "memberRole",
        },
      }).then((res) => {
        this.roleList = res || [];
      });
    },
    getMemberInfo() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_INFO_BYID,
        para,
      }).then((res) => {
        this.memberInfo = res;
      });
    },
  },
  created() {
    const { id } = this.$route.query;
    if (id) {
      this.para.id = parseInt(id);
      this.getMemberInfo();
      this.getRoleList();
      this.getPayTypeList();
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id } = to.query;
    if (id) {
      this.para.id = parseInt(id);
      this.getMemberInfo();
      this.getRoleList();
      this.getPayTypeList();
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.query_item {
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid rgb(227, 227, 227);
  margin-bottom: 0 !important;
}
.query {
  height: 60px;
  line-height: 60px;
  margin-bottom: 0 !important;
  & .label {
    color: #000;
    font-size: 14px;
  }
  & .value {
    color: #1890ff;
    font-size: 24px;
  }
}
</style>
